import { useEffect, useRef } from "react"

export const useLatestRef = (obj) => {
  const ref = useRef(obj)
  ref.current = obj
  return ref
}

export const useScrollEvent = (scrollEvent) => {
  const eventRef = useLatestRef(scrollEvent)
  useEffect(() => {
    const event = () => {
      eventRef.current?.()
    }
    event()
    window.addEventListener("scroll", event)

    return () => {
      window.removeEventListener("scroll", event)
    }
  }, [eventRef])
}

export const usePlayVideo = (videoRef) => {
  useEffect(() => {
    videoRef.current && videoRef.current.play()
    if (typeof window.WeixinJSBridge === "undefined") {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          videoRef.current && videoRef.current.play()
        },
        false
      )
    } else {
      window.WeixinJSBridge.invoke(
        "getNetworkType",
        {},
        function (e) {
          videoRef.current && videoRef.current.play()
        },
        false
      )
    }
  }, [videoRef])
}
